/** @format */
import {validateOrderWithErrors} from 'frontier/ds/quoter/functions/validate';
import React, {useCallback, useContext, useEffect, useState} from 'react';
import {ActionColumn} from './table_columns/action_column';
import {FileColumn} from './table_columns/file_column';
import {SearchContext} from 'frontier-search';
import {If, IfElse} from 'frontier-utilities';
import {Table} from '@sttark/design-system';

export const DesignsList = props => {
    const searchCtx = useContext(SearchContext);
    const {renderData: order} = props;

    const [isShowingAll, setIsShowingAll] = useState(searchCtx.search != '' ? false : true);

    const [matchingDesignIds, setMatchingDesignIds] = useState([]);

    const [isShowingThumbnails, setIsShowingThumbnails] = useState(true);

    // bypasses the errors that prevent some of the order actions. User usage discouraged
    const [byPassError, setByPassError] = useState(false);

    const handleToggleShowAllDesigns = useCallback(() => {
        setIsShowingAll(!isShowingAll);
    }, [isShowingAll]);

    useEffect(() => {
        const {matchingDesignIds: newMatchingDesignids} = searchCtx.extraData;

        if (
            newMatchingDesignids &&
            newMatchingDesignids.length > 0 &&
            newMatchingDesignids != matchingDesignIds
        ) {
            setIsShowingAll(true);
        }
    }, [searchCtx.extraData]);

    const filterDesigns = ({design}) => {
        if (matchingDesignIds.length == 0 || isShowingAll) {
            return true;
        }

        return matchingDesignIds.findIndex(designId => String(designId) == String(design.id)) > -1;
    };

    let filteredDesigns = order.designs_orders.filter(filterDesigns);

    if (!isShowingAll && filteredDesigns.length > 5) {
        filteredDesigns = filteredDesigns.slice(0, 5);
    }

    const {isComplete: isReorderPossible, errors: orderValidationErrors} =
        validateOrderWithErrors(order);

    const handleToggleThumbnails = () => {
        setIsShowingThumbnails(!isShowingThumbnails);
    };

    // matchingIds need to be of type array
    useEffect(() => {
        const matchingIds = searchCtx.extraData.matchingDesignIds;
        if (Array.isArray(matchingIds)) {
            setMatchingDesignIds(matchingIds);
        } else if (typeof matchingIds === 'object' && !Array.isArray(matchingIds)) {
            setMatchingDesignIds(Object.values(matchingIds));
        } else {
            setMatchingDesignIds([]);
        }
    }, [searchCtx.extraData.matchingDesignIds]);

    if (filteredDesigns.length == 0) {
        return <></>;
    }

    return (
        <div>
            <If condition={!isReorderPossible}>
                <div className="d-flex align-items-center">
                    <div className="text-info">Reordering is Not Available</div>
                </div>
                <ul>
                    {orderValidationErrors.map((e, index) => {
                        if (e.message.toLowerCase().includes('round to nearest 1/')) {
                            return (
                                <React.Fragment key={index}>
                                    <IfElse condition={!byPassError}>
                                        <>
                                            <li key={index}>{e.message}</li>
                                            <button
                                                className="color-alert-negative"
                                                onClick={() => setByPassError(true)}>
                                                <u>Bypass size error</u>
                                            </button>
                                        </>
                                        <li className="alert alert-info my-1 p-2">
                                            You have chosen to bypass a size error
                                        </li>
                                    </IfElse>
                                </React.Fragment>
                            );
                        }
                        return <li key={index}>{e.message}</li>;
                    })}
                </ul>
            </If>
            <Table
                columns={[
                    {
                        index: 'filename',
                        title: (
                            <div className="table-column-title d-flex align-items-center justify-content-start">
                                <b className="m-0 p-0">Filename</b>
                                <button
                                    className="color-accent-primary ml-2 my-0 p-0"
                                    onClick={handleToggleThumbnails}>
                                    <u>{isShowingThumbnails ? 'Hide' : 'Show'}</u>
                                </button>
                            </div>
                        ),
                        key: 'filename'
                    },
                    {
                        index: 'design_id',
                        title: 'Design ID',
                        key: 'design_id'
                    },
                    {
                        index: 'design_qty',
                        title: 'Design Qty',
                        key: 'design_qty'
                    },
                    {
                        index: 'action',
                        key: 'action',
                        title: ''
                    }
                ]}
                rows={order.designs_orders.map(design_order => {
                    return {
                        key: design_order.id,
                        filename: (
                            <FileColumn
                                order={order}
                                designOrder={design_order}
                                showThumbnails={isShowingThumbnails}
                            />
                        ),
                        design_id: design_order.design_id,
                        design_qty: design_order.qty,
                        action: (
                            <ActionColumn
                                order={order}
                                designOrder={design_order}
                                shouldByPassErrors={byPassError}
                            />
                        )
                    };
                })}
            />
            <If condition={order.designs_orders.length != filteredDesigns.length}>
                <button
                    className="p-0 mb-0 mt-2 color-accent-primary"
                    onClick={handleToggleShowAllDesigns}>
                    <u>Show All Designs</u>
                </button>
            </If>
        </div>
    );
};
